import { INVITATION_ACCEPTANCE_SESSION_KEY } from '../const/invitation-acceptance-session-key.const'

export function hasRecentInvitationAcceptanceInSession(): boolean {
  try {
    return sessionStorage.getItem(INVITATION_ACCEPTANCE_SESSION_KEY) === 'true'
  } catch {
    return false
  }
}
